import { Button, DatePicker, Table } from "antd";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { partnerTrackingStatsSelector } from "../../feature/partner-details/partnerDetailsSelector";
import { getPartnerTrackingStatsRequest } from "../../feature/partner-details/partnerDetailsSlice";
import { appConfig } from "../../utils/appConfig";

const TrackingStats = ({ id }) => {
  const [startDate, setStartDate] = useState(moment("2022-01-01"));
  const [endDate, setEndDate] = useState(moment(new Date()));
  const { listPartnerTrackingStat } = useSelector(({ partnerDetailsState }) =>
    partnerTrackingStatsSelector(partnerDetailsState)
  );
  const dispatch = useDispatch();

  const columns = useMemo(() => {
    const result = [
      {
        title: "Tracking Link Code",
        dataIndex: "code",
        key: "code",
      },
      {
        title: "Hits",
        dataIndex: "hit",
        key: "hit",
      },
      {
        title: "Signups",
        dataIndex: "signup",
        key: "signup",
      },
      {
        title: "Paid",
        dataIndex: "paid",
        key: "paid",
      },
    ];
    return result;
  }, []);

  const onFilter = () => {
    dispatch(
      getPartnerTrackingStatsRequest({
        id,
        st: moment(startDate).endOf("day").toISOString(),
        et: moment(endDate).endOf("day").toISOString(),
      })
    );
  };

  useEffect(() => {
    onFilter();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="ledger-container">
      <div className="filter-container mt-25">
        <div className="mr-5">
          <div>Start Date</div>
          <DatePicker
            placeholder="DD MMM YYYY"
            format="DD MMM YYYY"
            onChange={(date) => setStartDate(date)}
            value={startDate}
          />
        </div>
        <div className="mr-25">
          <div>End Date</div>
          <DatePicker
            placeholder="DD MMM YYYY"
            format="DD MMM YYYY"
            onChange={(date) => setEndDate(date)}
            value={endDate}
          />
        </div>
        <div>
          <div className="hidden">filter</div>
          <Button type="primary" onClick={onFilter}>
            Filter
          </Button>
        </div>
      </div>
      <div className="max-w-1100 mt-25">
        <Table
          className="mt-5"
          columns={columns}
          dataSource={listPartnerTrackingStat}
          bordered
          pagination={{
            pageSize: appConfig.PAGE_SIZE,
          }}
          rowKey="_id"
        />
      </div>
    </div>
  );
};

export default TrackingStats;
